const ActLive = [
  {
    path: '/keysight200316/index',
    name: 'keysight200316',
    component: resolve => require(['@/actlive/keysight200316/index'], resolve),
    meta: {
      title: '从超低微功率电源效率分析'
    }
  },
  {
    path: '/page/([a-z]?)25',
    name: 'page25',
    component: resolve => require(['@/actlive/keysight200316/index'], resolve),
    meta: {
      title: '从超低微功率电源效率分析'
    }
  },
  {
    path: '/page/([a-z]?)28',
    name: 'page28',
    component: resolve => require(['@/actlive/keysight200401/index'], resolve),
    meta: {
      title: '参与是德问卷 赢取演讲资料' // keysight 4.25直播中页面  调查问卷+表单提交
    }
  },
  {
    path: '/keysight200401/download',
    name: 'keysight200401Download',
    component: resolve => require(['@/actlive/keysight200401/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/page/([a-z]?)33',
    name: 'page33',
    component: resolve => require(['@/actlive/laoshou200514/index'], resolve),
    meta: {
      title: '逆变器实训营-从0到1做逆变' // 萧山老寿直播聚合页
    }
  },
  {
    path: '/laoshou200601/index',
    name: 'laoshou200601Index',
    component: resolve => require(['@/actlive/laoshou200601/index'], resolve),
    meta: {
      title: '逆变器实训营-从0到1做逆变' // 老寿邀请三人解锁回放参加活动页
    }
  },
  {
    path: '/laoshou200601/success',
    name: 'laoshou200601Success',
    component: resolve => require(['@/actlive/laoshou200601/success'], resolve),
    meta: {
      title: '逆变器实训营-从0到1做逆变' // 老寿邀请三人解锁回放提交成功页
    }
  },
  {
    path: '/infineon200610/index',
    name: 'infineon200610',
    component: resolve => require(['@/actlive/infineon200610/index'], resolve),
    meta: {
      title: '英飞凌安全大师走进“云”校园' // 英飞凌618直播中问卷
    }
  },
  {
    path: '/infineon200727/index',
    name: 'infineon200727',
    component: resolve => require(['@/actlive/infineon200727/index'], resolve),
    meta: {
      title: '宽禁带功率半导体技术及应用————SiC & GaN' // 英飞凌8.3号直播中问卷
    }
  },
  {
    path: '/infineon200728/index',
    name: 'infineon200728',
    component: resolve => require(['@/actlive/infineon200728/index'], resolve),
    meta: {
      title: '解密英飞凌传感技术，雷达与ToF助力智慧生活' // 英飞凌8.4号直播中问卷
    }
  },
  {
    path: '/infineon200729/index',
    name: 'infineon200729',
    component: resolve => require(['@/actlive/infineon200729/index'], resolve),
    meta: {
      title: '安全大解码：数字新世界中的身份鉴别' // 英飞凌8.5号直播中问卷
    }
  },
  {
    path: '/infineon200730/index',
    name: 'infineon200730',
    component: resolve => require(['@/actlive/infineon200730/index'], resolve),
    meta: {
      title: '面向未来需求的汽车电子微控制器' // 英飞凌8.6号直播中问卷
    }
  },
  {
    path: '/per/over',
    name: 'perOver',
    component: resolve => require(['@/actlive/infineon200727/over'], resolve),
    meta: {
      title: '欢迎您下午2点观看此直播' // 英飞凌8.3号-8.6号直播预报名已结束页
    }
  },
  {
    path: '/duzuobing210621/index',
    name: 'duzuobing210621',
    component: resolve => require(['@/actlive/duzuobing210621/index'], resolve),
    meta: {
      title: '杜佐兵读者福利'
    }
  }
]

export default ActLive
